
export default {
    methods: {
        returnStyle() {
            return [
                {
                    featureType: "administrative",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#444444",
                        },
                    ],
                },
                {
                    featureType: "landscape",
                    elementType: "all",
                    stylers: [
                        {
                            color: "#f2f2f2",
                        },
                    ],
                },
                {
                    featureType: "poi",
                    elementType: "all",
                    stylers: [
                        {
                            visibility: "off",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: -100,
                        },
                        {
                            lightness: 45,
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "all",
                    stylers: [
                        {
                            visibility: "simplified",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                    ],
                },
                {
                    featureType: "road.arterial",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            visibility: "off",
                        },
                    ],
                },
                {
                    featureType: "transit",
                    elementType: "all",
                    stylers: [
                        {
                            visibility: "off",
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "all",
                    stylers: [
                        {
                            color: "#dde6e8",
                        },
                        {
                            visibility: "on",
                        },
                    ],
                },
            ];
        },

        getTipiFatturato(base) {
            return [
                {
                    item: "verde",
                    value: "oltre 15.000€",
                    image: base + "cliente-verde.png",
                },
                {
                    item: "giallo",
                    value: "tra 5.000€ e 15.000€",
                    image: base + "cliente-giallo.png",
                },
                {
                    item: "rosso",
                    value: "meno di 5.000€",
                    image: base + "cliente-rosso.png",
                },
            ]
        },

        getTipiInit() {
            return [
                { text: "Tutti", value: "tutti", image: "" },
                {
                    text: "Showroom",
                    value: "showroom",
                    image: this.$load.getUrlImg() + "\\mappe\\pointers\\showroom.png",
                },
                {
                    text: "Clienti",
                    value: "clienti",
                    image: this.$load.getUrlImg() + "\\mappe\\pointers\\cliente.png",
                },
                {
                    text: "Tutti potenziali clienti",
                    value: "p_tutti",
                    image: this.$load.getUrlImg() + "\\mappe\\pointers\\tutti.png"
                },
                {
                    text: "Showroom",
                    value: "p_Showroom",
                    image: this.$load.getUrlImg() + "\\mappe\\pointers\\Showroom potenziale.png"
                },
                {
                    text: "Falegname",
                    value: "p_Falegname",
                    image: this.$load.getUrlImg() + "\\mappe\\pointers\\Falegname.png"
                },
                {
                    text: "Magazino edile",
                    value: "p_Magazino",
                    image: this.$load.getUrlImg() + "\\mappe\\pointers\\Magazzino.png"
                },
                {
                    text: "Progettista",
                    value: "p_Progettista",
                    image: this.$load.getUrlImg() + "\\mappe\\pointers\\Progettista.png"
                },
                {
                    text: "Serramentista",
                    value: "p_Serramentista",
                    image: this.$load.getUrlImg() + "\\mappe\\pointers\\VetroSerramentisti.png"
                },
            ]
        },
    }
}